import React from "react";
import { Popover } from "@vapor/react-material/Popover";
import { ListItemButton } from "@vapor/react-material/ListItemButton";
import { List } from "@vapor/react-material/List";
import { ListItemText } from "@vapor/react-material/ListItemText";
import { Props } from "../../types";

const OrderPopover: React.FC<Props> = ({ anchorEl, onClose }) => {
  const open = Boolean(anchorEl);

  return (
    <div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List disablePadding sx={{ width: 240 }}>
          <ListItemButton>
            <ListItemText primary="Alfabetica A-Z" />
          </ListItemButton>
          <ListItemButton component="a">
            <ListItemText primary="Alfabetica Z-A" />
          </ListItemButton>
          <ListItemButton component="a">
            <ListItemText primary="I piu recenti" />
          </ListItemButton>
          <ListItemButton component="a">
            <ListItemText primary="I meno recenti" />
          </ListItemButton>
        </List>
      </Popover>
    </div>
  );
};

export default OrderPopover;
